<template>
  <LMap v-bind="options" @update:zoom="$emit('update:zoom', $event)" @ready="onMapReady">
    <LTileLayer :tile-layer-class="getTileLayerClass" />
    <MapMarker
      v-for="marker in markers"
      v-bind="marker"
      :key="getMarkerKey(marker)"
      @click="$emit('markerClick', $event)"
      @dragend="$emit('markerMove', $event)"
    />
    <MapPolygon
      v-for="area in areas"
      v-bind="area"
      :key="area.id"
      @click="$emit('areaClick', $event)"
      @change="$emit('areaChange', $event)"
    />
  </LMap>
</template>

<script>
import TileLayer from '../leaflet/TileLayer'
import MapMarker from './MapMarker.vue'
import { LMap, LTileLayer } from 'vue2-leaflet'
import { DEFAULT_MAP_OPTIONS } from '@/store/modules/map'
import MapPolygon from '@/components/map/MapPolygon.vue'

export default {
  name: 'Map',
  components: {
    MapPolygon,
    MapMarker,
    LTileLayer,
    LMap
  },
  props: {
    areas: {
      type: Array,
      default: () => []
    },
    markers: {
      type: Array,
      default: () => []
    },
    options: {
      type: Object,
      default: () => ({ ...DEFAULT_MAP_OPTIONS })
    }
  },
  data: () => ({}),
  computed: {},
  methods: {
    getTileLayerClass(url, options) {
      return new TileLayer(url, options)
    },
    getMarkerKey(marker) {
      const keyParts = [
        marker.id,
        marker.tooltip,
        marker.print ? 'print' : 'web',
        marker.tooltipOptions?.direction ?? '',
        marker.permanentTooltip,
      ]
      return keyParts.join('--')
    },
    onMapReady(map) {
      this.$emit('ready', map)
    }
  }
}
</script>

<style>
@media print {
  .leaflet-control-zoom {
    display: none;
  }
}
</style>
